let zeroize = num => {
  return (String(num).length == 1 ? '0' : '') + num;
}
export let filterK = (v) => {
    let val = Number(v)
    return val >= 1000 ? (val / 1000).toFixed(1) + 'k' : val;
}
export let filter_price = num => {
  if (num < 0 || num == 0) {
      return 0;
  }
  return num / 100;
}
export let formattime = (timestamp) => {
    var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
    timestamp = String(timestamp).length > 12 ? timestamp / 1000 : timestamp
    var timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数
    var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
    var tmDate = new Date(timestamp * 1000); // 参数时间戳转换成的日期对象
    var Y = tmDate.getFullYear(),
        m = tmDate.getMonth() + 1,
        d = tmDate.getDate();
    var H = tmDate.getHours(),
        i = tmDate.getMinutes(),
        s = tmDate.getSeconds();
    if (timestampDiff < 60) { // 一分钟以内
        return "刚刚";
    } else if (timestampDiff < 3600) { // 一小时前之内
        return Math.floor(timestampDiff / 60) + "分钟前";
    } else if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
        return '今天 ' + zeroize(H) + ':' + zeroize(i);
        //  + zeroize(H) + ':' + zeroize(i);
    } else {
        var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
        if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
            return '昨天 ' + zeroize(H) + ':' + zeroize(i);
            //  + zeroize(H) + ':' + zeroize(i);
        } else if (curDate.getFullYear() == Y) {
            return zeroize(m) + '-' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i);
            //  + zeroize(H) + ':' + zeroize(i);
        } else {
            // Y + '-' +
            return zeroize(m) + '-' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i);
        }
    }
}
/**
 *
 * @param {时间戳} date 必须是毫秒数
 * @returns
 */
export let dateDiff = (date) => {
  var date2 = new Date();
  var iDays = parseInt(Math.abs(date2.getTime() - date) / 1000 / 60 / 60 / 24);
  return iDays < 1 ? 1 : iDays;
}

/**
 * 千位分隔符
 * @param {数字} numStr
 * @returns
 */
export let thousandBitSeparator = (numStr) => {
  numStr = typeof numStr === 'number' ? numStr.toString() : numStr
  if (numStr.length > 3) {
    var reg = /(?=(\B\d{3})+$)/g;
    return numStr.replace(reg, ",")
  } else {
    return numStr
  }
}

function add0(m) { return m < 10 ? '0' + m : m }

export let format = (shijianchuo) => {
    var new_date = shijianchuo*1000 || new Date().getTime();
    //new_date是整数，否则要parseInt转换
    var time = new Date(new_date);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + '/' + add0(m) + '/' + add0(d);
}
export let formatAll = (shijianchuo) => {
    var new_date = String(shijianchuo).length > 12 ? shijianchuo : shijianchuo*1000 || new Date().getTime();
    //new_date是整数，否则要parseInt转换
    var time = new Date(new_date);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
}
export let format2 = (shijianchuo) => {
    var new_date = String(shijianchuo).length > 12 ? shijianchuo : shijianchuo * 1000 || new Date().getTime();

    //new_date是整数，否则要parseInt转换
    var time = new Date(new_date);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + '-' + add0(m) + '-' + add0(d);
}

export let formatMD = (shijianchuo) => {
    var new_date = shijianchuo*1000 || new Date().getTime();
    //new_date是整数，否则要parseInt转换
    var time = new Date(new_date);
    var m = time.getMonth() + 1;
    var d = time.getDate();
    return add0(m) + '-' + add0(d);
}

export const probablyNum = (num) => {
  let number;
  if(num >= 10000) {
      number = (num / 10000).toFixed(2) + 'w';
  } else {
      number = num;
  }
  return number;
}

export const diffTime = (time) => {
  var nowTime = +new Date(); // 返回的是当前时间总的毫秒数
  var inputTime = +new Date(time); // 返回的是用户输入时间总的毫秒数
  var times = (inputTime - nowTime) / 1000; // times是剩余时间总的秒数
  var d = parseInt(times / 60 / 60 / 24); // 天
  d = d < 10 ? '0' + d : d;
  var h = parseInt(times / 60 / 60 % 24); //时
  h = h < 10 ? '0' + h : h;
  // var m = parseInt(times / 60 % 60); // 分
  // m = m < 10 ? '0' + m : m;
  // var s = parseInt(times % 60); // 当前的秒
  // s = s < 10 ? '0' + s : s;
  // return d + '天' + h + '时' + m + '分' + s + '秒';
  return d === '00' ? h + '小时' : d + '天' + h + '小时';
}

// 字节换算
export const byteConvert  = (bytes) => {
  if (isNaN(bytes)) {
    return '';
  }
  var symbols = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var exp = Math.floor(Math.log(bytes)/Math.log(2));
  if (exp < 1) {
    exp = 0;
  }
  var i = Math.floor(exp / 10);
  bytes = bytes / Math.pow(2, 10 * i);

  if (bytes.toString().length > bytes.toFixed(2).toString().length) {
    bytes = bytes.toFixed(2);
  }
  return bytes + ' ' + symbols[i];
}



// WEBPACK FOOTER //
// ./src/plugin/filters.js